const config = {
  NAME: 'Colaborador',
  PATH: '/colaborador',
};

export default config;
